// USAGE:
/* ELEMENT, CLASS TO APPEND, IDENTIFIER
/* _$(`<span class="close"></span>`, '.article-body', 1) */

/*** lib.js is a variation of 
 * IntlyPlus https://github.com/christophernathaniel/IntlyPlus 
 * for use only with Linassi+CO projects.
 * ***/

// USAGE:
/* ELEMENT, CLASS TO APPEND, IDENTIFIER
/* _$(`<span class="close"></span>`, '.article-body', 1) */

import lib from "./lib";

const _$ = {
  create: (str, qs, identifier) => {
    // Init DOM Parser
    let doc = new DOMParser().parseFromString(str, "text/html");
    

    let e = lib.qs('[_s="' + identifier + '"]');

    if(e) {
      if (e.getAttribute("_s") == identifier) {
        e.remove(); // If node exists, remove it
      }
    }

    // Create New Node
    if(qs) {
      let elem = qs;

      if(!doc.body.innerHTML) {
        console.error('JSR ERROR: No HTML to append');
        console.error(doc.body.innerHTML);
        console.error('END JSR ERROR');
        return false;
      }

      if(!elem) {
        console.error('JSR ERROR: Element not vaid');
        console.error(elem);
        console.error('END JSR ERROR');
        return false;
      }

      if(typeof qs === 'string') {
        elem = lib.qs(qs);
      }

      
      elem.insertAdjacentHTML("beforeend", doc.body.innerHTML);

    
      elem.children[elem.children.length - 1].setAttribute("_s", identifier);
      elem.children[elem.children.length - 1].setAttribute(
        "uuid",
        Math.floor(Math.random() * 9999999999)
      );
  
      return elem.children[elem.children.length - 1];

    }


    if(!qs) {
      doc.children[doc.children.length - 1].setAttribute("_s", identifier);
      doc.children[doc.children.length - 1].setAttribute(
        "uuid",
        Math.floor(Math.random() * 9999999999)
      );
      return doc;
    }
  

  
  },
  delete: () => {},
  unwrap: (elem) => {

    // Usage: _$.upwrap(element)
      // Get a reference to the container div
      let containerDiv = elem;

      // Check if the container div exists
      if (elem) {
          // Get a reference to the container's parent node
          var parent = elem.parentNode;
  
          // Loop through each child node of the container div and append it to the parent
          while (elem.firstChild) {
              parent.insertBefore(elem.firstChild, elem);
          }
  
          // Remove the container div from the DOM
          parent.removeChild(elem);
      }
  }
};

export { _$ };
